import React from 'react'
import { Collapse } from 'react-bootstrap'
import { ArrowIcon } from '../Icons/ArrowIcon'
import { colors } from '../../styles/colors'
import styled from 'styled-components'
import { useLocalReturnsState } from '../../stores/LocalReturnsProvider'
import { StyledItemWrapper } from '../TreeList/treeList'
import { useTranslation } from 'react-i18next'
import StorehouseFilter from '../Filter/StorehouseFilter'
import DateRangeFilter from '../Filter/DateRangeFilter'
import OfficeFilter from '../Filter/OfficeFilter'
import CostCenterFilter from '../Filter/CostCenterFilter'

const StyledCollapseWrapper = styled.div`
  margin-bottom: 25px;
 

  ${StyledItemWrapper} {
    background-color: #FFF;
  }

`

const StyledFilterToggle = styled.h2`
  cursor: pointer;
  display: flex;
  align-items: center;
  color: ${colors.gray5};
  font-size: 20px;
  margin-bottom: 10px;
  ${ArrowIcon} {
    margin-right: 10px;
  }
`

const OverlayLeftFilter = () => {
  const {
    openOfficeFilter,
    setOpenOfficeFilter,
    openCostCenterFilter,
    setOpenCostCenterFilter,
    openStorehouseFilter, setOpenStorehouseFilter,
    storehouseFilter, setStorehouseFilter,
    openDateRangeFilter, setOpenDateRangeFilter,
    startDateFilter, setStartDateFilter,
    endDateFilter, setEndDateFilter,
    setOfficeFilter, setOfficeName,
    setCostCenterFilter, setCostCenterName,
  } = useLocalReturnsState()
  const { t } = useTranslation()
  return (
    <>
      <StyledCollapseWrapper>
        <StyledFilterToggle onClick={() => setOpenOfficeFilter(!openOfficeFilter)} aria-controls="office-collapse"
          aria-expanded={openOfficeFilter}>
          <ArrowIcon variant={openOfficeFilter ? 'down' : 'right'} color={colors.gray5} />{t('orgaUnit')} ({t('orgaUnitShortcut')})
        </StyledFilterToggle>
        <Collapse in={openOfficeFilter}>
          <div id="office-collapse">
            {openOfficeFilter && <OfficeFilter setOfficeFilter = {setOfficeFilter} setOfficeName = {setOfficeName}/>}
          </div>
        </Collapse>
      </StyledCollapseWrapper>
      {<StyledCollapseWrapper>
        <StyledFilterToggle onClick={() => setOpenCostCenterFilter(!openCostCenterFilter)}
          aria-controls="costCenter-collapse" aria-expanded={openCostCenterFilter}>
          <ArrowIcon variant={openCostCenterFilter ? 'down' : 'right'} color={colors.gray5} />{t('costcenter')} ({t('costcenterShortcut')})
        </StyledFilterToggle>
        <Collapse in={openCostCenterFilter}>
          <div id="costCenter-collapse">
            {openCostCenterFilter && <CostCenterFilter setCostCenterFilter = {setCostCenterFilter} setCostCenterName = {setCostCenterName}/>}
          </div>
        </Collapse>
      </StyledCollapseWrapper>}
    <StyledCollapseWrapper>
        <StyledFilterToggle onClick={() => setOpenStorehouseFilter(!openStorehouseFilter)}
            aria-controls="storehouse-collapse" aria-expanded={openStorehouseFilter}>
            <ArrowIcon variant={openStorehouseFilter ? 'down' : 'right'} color={colors.gray5} />{t('returnsTable:warehouse')} ({t('returnsTable:warehouseShortcut')})
        </StyledFilterToggle>
        <Collapse in={openStorehouseFilter}>
            <div id="storehouse-collapse">
            <StorehouseFilter storehouseFilter = {storehouseFilter} setStorehouseFilter = {setStorehouseFilter} showIsVirtual={false}/>
            </div>
        </Collapse>
    </StyledCollapseWrapper>
      <StyledCollapseWrapper>
        <StyledFilterToggle onClick={() => setOpenDateRangeFilter(!openDateRangeFilter)}
          aria-controls="dateRange-collapse" aria-expanded={openDateRangeFilter}>
          <ArrowIcon variant={openDateRangeFilter ? 'down' : 'right'} color={colors.gray5} />{t('returnsTable:expectedTimeOfArrival')}
        </StyledFilterToggle>
        <Collapse in={openDateRangeFilter}>
          <div id="dateRange-collapse">
            <DateRangeFilter dateFrom = {startDateFilter} setDateFrom = {setStartDateFilter} dateTo = {endDateFilter} setDateTo = {setEndDateFilter}/>
          </div>
        </Collapse>
      </StyledCollapseWrapper>
    </>
  )
}

export default OverlayLeftFilter
